import { jsx } from 'react/jsx-runtime';
import Lottie from 'react-lottie-player';
import classNames from 'classnames';
import BTC from './icons/BTC.json.es.js';
import Bank from './icons/Bank.json.es.js';
import BankBlue from './icons/BankBlue.json.es.js';
import BarChart from './icons/BarChart.json.es.js';
import BarChartOrange from './icons/BarChartOrange.json.es.js';
import BasketSwing from './icons/BasketSwing.json.es.js';
import Building from './icons/Building.json.es.js';
import Card from './icons/Card.json.es.js';
import Caution from './icons/Caution.json.es.js';
import Chain from './icons/Chain.json.es.js';
import ChainBlue from './icons/ChainBlue.json.es.js';
import Check from './icons/Check.json.es.js';
import Convert from './icons/Convert.json.es.js';
import Documents from './icons/Documents.json.es.js';
import ETH from './icons/ETH.json.es.js';
import Link from './icons/Link.json.es.js';
import LoadingSpinner from './icons/LoadingSpinner.json.es.js';
import Lock from './icons/Lock.json.es.js';
import PaperPlane from './icons/PaperPlane.json.es.js';
import PencilRuler from './icons/PencilRuler.json.es.js';
import Percent from './icons/Percent.json.es.js';
import Rocket from './icons/Rocket.json.es.js';
import Target from './icons/Target.json.es.js';
import Transfer from './icons/Transfer.json.es.js';
import Transfer45 from './icons/Transfer45.json.es.js';
import TrendLine from './icons/Trending.json.es.js';
import USDC from './icons/USDC.json.es.js';
import USDCRenew from './icons/USDCRenew.json.es.js';
import User from './icons/User.json.es.js';
import World from './icons/World.json.es.js';

/**
 * List of available LottieIcons.
 */ const LottieIconsList = {
    Bank,
    BankBlue,
    BarChart,
    BarChartOrange,
    BasketSwing,
    BTC,
    Building,
    Card,
    Caution,
    Chain,
    ChainBlue,
    Check,
    Convert,
    Documents,
    ETH,
    Link,
    Lock,
    LoadingSpinner,
    PaperPlane,
    PencilRuler,
    Percent,
    Rocket,
    Target,
    Transfer,
    Transfer45,
    TrendLine,
    USDC,
    USDCRenew,
    User,
    World
};
const LottieIcon = ({ name, width = 152, height = 152, speed = 1, isPlaying = true, loop = false, preserveAspectRatio = 'xMidYMid meet', onComplete })=>{
    const iconName = name.toLowerCase();
    // Get the raw animation data for the given icon
    const animationData = LottieIconsList[name];
    return jsx(Lottie, {
        animationData: animationData,
        className: classNames('cb-lottie-icon', {
            [`cb-lottie-icon-${iconName}`]: iconName
        }),
        "data-testid": `lottie-icon-${iconName}`,
        loop: loop,
        onComplete: onComplete,
        play: isPlaying,
        rendererSettings: {
            preserveAspectRatio
        },
        speed: speed,
        style: {
            width,
            height
        }
    });
};
LottieIcon.displayName = 'LottieIcon';

export { LottieIcon, LottieIconsList, LottieIcon as default };
//# sourceMappingURL=LottieIcon.es.js.map
